The parent job category.

This is a more general classification that this category belongs to.
It will be `null` for root categories that do not belong to a more general classification.
